import React, { useState } from "react";
import { CROWN_BUNDLES } from "../data/cosmeticItems";
import { buyCrowns } from "../lib/api";
import CrownCoin from "./CrownCoin";
import { DS } from "../theme";

export default function CrownPurchaseModal({ user, crowns, onClose }) {
  const [loading, setLoading] = useState(null);
  const [error, setError]     = useState(null);

  async function handleBuy(bundle) {
    if (!user?.token) return;
    setLoading(bundle.id);
    setError(null);
    try {
      const data = await buyCrowns(user.token, bundle.id);
      if (data.url) { window.location.href = data.url; return; }
      setError(data.error || "Could not start checkout.");
    } catch {
      setError("Could not reach server. Try again.");
    }
    setLoading(null);
  }

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 300,
        background: "rgba(0,0,0,0.78)", backdropFilter: "blur(5px)",
        display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: DS.surface,
          border: "1px solid rgba(212,175,55,0.25)",
          borderRadius: DS.radius + 4,
          padding: "28px 24px",
          maxWidth: 380, width: "100%",
          boxShadow: "0 24px 64px rgba(0,0,0,0.65)",
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ marginBottom: 10 }}>
            <CrownCoin size={52} shimmer />
          </div>
          <div className="cinzel" style={{ fontSize: 17, fontWeight: 700, color: DS.text, marginBottom: 4 }}>
            Buy Crowns
          </div>
          <div style={{ fontSize: 12, color: DS.textMuted }}>
            Balance: <span style={{ color: "#D4AF37", fontWeight: 600 }}>{crowns.toLocaleString()} 👑</span>
          </div>
        </div>

        {/* Bundles */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
          {CROWN_BUNDLES.map(bundle => (
            <button
              key={bundle.id}
              onClick={() => handleBuy(bundle)}
              disabled={!!loading || !user}
              style={{
                position: "relative",
                display: "flex", alignItems: "center", justifyContent: "space-between",
                background: bundle.bonus
                  ? "linear-gradient(135deg, rgba(212,175,55,0.12), rgba(115,102,240,0.08))"
                  : DS.elevated,
                border: `1px solid ${bundle.bonus ? "rgba(212,175,55,0.42)" : DS.borderFaint}`,
                borderRadius: 10, padding: "14px 18px",
                cursor: "pointer", transition: "all 0.15s", textAlign: "left",
              }}
            >
              {bundle.bonus && (
                <span style={{
                  position: "absolute", top: -9, right: 12,
                  background: DS.accent, color: "#fff",
                  fontSize: 9, fontWeight: 700, borderRadius: 6,
                  padding: "2px 7px", textTransform: "uppercase", letterSpacing: "0.06em",
                }}>{bundle.bonus}</span>
              )}
              <div>
                <div className="cinzel" style={{ fontSize: 16, fontWeight: 700, color: "#D4AF37", marginBottom: 2 }}>
                  👑 {bundle.crowns.toLocaleString()}
                </div>
                <div style={{ fontSize: 11, color: DS.textMuted }}>Crowns</div>
              </div>
              <div className="cinzel" style={{
                fontSize: 14, fontWeight: 700, color: DS.text,
                background: DS.bg, borderRadius: 7, padding: "7px 16px",
                border: `1px solid ${DS.borderFaint}`,
                minWidth: 72, textAlign: "center",
              }}>
                {loading === bundle.id ? "…" : `$${bundle.price.toFixed(2)}`}
              </div>
            </button>
          ))}
        </div>

        {error && (
          <div style={{ fontSize: 12, color: DS.danger, textAlign: "center", marginBottom: 14 }}>
            {error}
          </div>
        )}

        <div style={{ fontSize: 11, color: DS.textFaint, textAlign: "center", lineHeight: 1.65, marginBottom: 18 }}>
          Crowns are used for cosmetics only · Not redeemable for cash
        </div>

        <button className="btn btn-ghost" onClick={onClose} style={{ width: "100%", justifyContent: "center" }}>
          Close
        </button>
      </div>
    </div>
  );
}
